export enum WizardActionType {
	REDIRECT = 'redirect',
	OPEN_MODAL = 'openModal',
}
